<template>
  <div class="qrcode-comp">
    <div class="input-area">
      <el-input v-model="text" :placeholder="$t('tool.QrcodeGenerator.phInput')" maxlength="500" show-word-limit @input="generate" />
    </div>
    <div class="qrcode-result" v-if="qrDataUrl">
      <img :src="qrDataUrl" alt="QR Code" style="width:200px;height:200px;" />
      <div style="margin-top:12px;">
        <el-button size="small" @click="download">{{ $t("common.action.download") }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QrcodeGenerator',
  props: { config: { type: Object, default: () => ({}) } },
  data: () => ({ text: '', qrDataUrl: '' }),
  methods: {
    generate() {
      if (this.text.trim()) {
        this.qrDataUrl = 'https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=' + encodeURIComponent(this.text)
      } else {
        this.qrDataUrl = ''
      }
    },
    async download() {
      const res = await fetch(this.qrDataUrl)
      const blob = await res.blob()
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      document.body.appendChild(a)
      a.href = url
      a.download = 'qrcode.png'
      a.click()
      document.body.removeChild(a)
      URL.revokeObjectURL(url)
    },
    doAction(action) {
      if (action === 'clear') { this.text = ''; this.qrDataUrl = '' }
    }
  }
}
</script>

<style scoped>
.qrcode-comp { }
.input-area { margin-bottom: 20px; }
.qrcode-result { text-align: center; }
</style>
